import type { TMsgTypesArr, TMsgTypes, TModes, IContext } from "msgdsk-types";

export const MsgTypesObj:TMsgTypes = {
	std: [0, "Msg", "Standard msg type with comments and submsges."],
	mail_box: [1, "Mail box", "Convinient blockchain mailbox with submailboxes"],
	forum: [2, "Forum", ""],
	chat: [3, "Chat", ""],
	gallery: [4, "Gallery", "Powerful photo gallery you can share or not."],
	blog: [5, "Blog", ""],
	personal: [6, "Personal Page", ""], 
	book: [7, "Book", ""],
	site: [8, "Website", "Site-like page"],
	diary: [9, "Daily Planner", ""],
	contacts: [10, "Contacts", ""],
	note: [11, "Note", ""],
	adver: [12, "Announcement", "Simple clear page for your things to be sold"],
	foto: [13, "Photo", ""],
	mini_blog: [14, "Miniblog", ""],
	drawer: [15, "Drawer", ""],
	link: [16, "Link", ""],
	sheet: [17, "Spreadsheet", ""],
	desk: [18, "Desk", "Your desk for all your msges."],
	contracts: [18, "Contracts on blockchain", ""],
	poo: [18, "Opening Proof Protocol", "Two-stage proof with Opening Proof and optional Acceptance Proof."],
	gallery2: [19, "Gallery 2", "Large visual gallery layout."],
	flickr: [20, "Flickr", "Dense attachment-backed photo collection."],
	instagram: [21, "Instagram", "Photo-post collection."],
	gmail: [22, "Gmail", "Mail-list desk."],
	twitter: [23, "Twitter", "Timeline and named lists."],
	facebook: [24, "Facebook", "Photo page, chat, and named sections."],
	hackernews: [25, "Hacker News", "Ranked stories and discussions."],
	fullscreen: [26, "Fullscreen", "Immersive full-screen scenes."],
	cards: [27, "Cards", "Card board and named sections."],
	presentation: [28, "Presentation", "Slide deck and chapters."],
	tiles: [29, "Tiles", "Tile dashboard and sections."],
	wiki: [30, "Wiki", "Answer-first linked knowledge tree."],
	email: [31, "Email", "Internal read-only email message."],
	music_box: [32, "Music Box", "Playlist containing Music Track messages."],
	music_track: [33, "Music Track", "Playable audio attachments with notes and comments."],
	portal: [34, "Portal", "A scoped directory of recursively contained msges."],
};				
export const MsgTypes:TMsgTypesArr = [
	["std", 0, "Msg", "Standard msg type with comments and submsges."],
	["mail_box", 1, "Mail box", "Convinient blockchain mailbox with submailboxes"],
	["forum", 2, "Forum", ""],
	["chat", 3, "Chat", ""],
	["gallery", 4, "Gallery", "Powerful photo gallery you can share or not."],
	["blog", 5, "Blog", ""],
	["personal", 6, "Personal Page", ""], 
	["book", 7, "Book", ""],
	["site", 8, "Website", "Site-like page"],
	["diary", 9, "Daily Planner", ""],
	["contacts", 10, "Contacts", ""],
	["note", 11, "Note", ""],
	["adver", 12, "Announcement", "Simple clear page for your things to be sold"],
	["foto", 13, "Photo", ""],
	["mini_blog", 14, "Miniblog", ""],
	["drawer", 15, "Drawer", ""],
	["link", 16, "Link", ""],
	["sheet", 17, "Spreadsheet", ""],
	// 18 is the persisted POO codec slot. The old Desk/Contracts placeholders
	// also claimed 18 without matching database message types, so they must not
	// be offered by the active create picker.
	["poo", 18, "Opening Proof Protocol", "Two-stage proof with Opening Proof and optional Acceptance Proof."],
	["gallery2", 19, "Gallery 2", "Large visual gallery layout."],
	["flickr", 20, "Flickr", "Dense attachment-backed photo collection."],
	["instagram", 21, "Instagram", "Photo-post collection."],
	["gmail", 22, "Gmail", "Mail-list desk."],
	["twitter", 23, "Twitter", "Timeline and named lists."],
	["facebook", 24, "Facebook", "Photo page, chat, and named sections."],
	["hackernews", 25, "Hacker News", "Ranked stories and discussions."],
	["fullscreen", 26, "Fullscreen", "Immersive full-screen scenes."],
	["cards", 27, "Cards", "Card board and named sections."],
	["presentation", 28, "Presentation", "Slide deck and chapters."],
	["tiles", 29, "Tiles", "Tile dashboard and sections."],
	["wiki", 30, "Wiki", "Answer-first linked knowledge tree."],
	["music_box", 32, "Music Box", "Playlist containing Music Track messages."],
	["music_track", 33, "Music Track", "Playable audio attachments with notes and comments."],
	["portal", 34, "Portal", "A scoped directory of recursively contained msges."],
];
export const Modes:TModes = {
	is_loading: {is_loading: "is_loading"},
	is_empty: {is_empty: "is_empty"}, 
	is_checking: {is_checking: "is_checking"}, 
	is_saving: {is_saving: "is_saving"}, 
	is_ok: {is_ok: "is_ok"},
	is_create: {is_create: "is_create"},
	is_captcha: {is_captcha: "is_captcha"},
	is_conf: {is_conf: "is_conf"},
	is_redirecting: {is_redirecting: "is_redirecting"},	
}; 
export const initAppStates = ( param?:IContext ):IContext => {
	return {
		state: "init",
		mode: Modes.is_empty,
		reset: [],
		find_enabled: false,
		namekey_error: false,
		sess_id: "",
		is_focused: "SearchInput",
		domain: "",
		origin: ["", "", "", ""],
		namekey: "",
		captcha: "",
		// captcha_rand: 1,
		pin: "",
		msgType: MsgTypes[0],
		is_google_it: false,
		is_pin_form: false,
		is_found: false,
		is_info_str: {},
		is_textarea: false,
		is_conf_form: false,
		is_info_str_create: "",
		app: {
			width: 0,
			widthCompact: 600,
			isCompact: false,
			menuWidth: 0
		},
		main_menu: { form: "", state: "" },
		prefix: "",
	}
};
export const InitStates:IContext = initAppStates(); 

/*  return type of an async function or 
method must be the global Promise<T> type. 
Did you mean to write 'Promise<IContext>'? */
